
































import eventBus from "@/utils/bus";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getRange, rangeSet } from "@/api/schedule";
@Component({
  name: "rangeDialog",
  components: {
    stepTimeRangeSelector,
  },
})
export default class extends Vue {
  dialogVisible: boolean = false;
  startTime: string = "";
  endTime: string = "";
  changeTime = 1;
  changeStartTime: string = "";
  changeEndTime: string = "";
  created() {
    getRange().then((res: any) => {
      if (res.error_code === 0) {
        this.startTime = res.data.start_time.slice(0, 5);
        if (res.data.end_time === "00:00:00") {
          res.data.end_time = "23:55:00";
        }
        this.endTime = res.data.end_time.slice(0, 5);
        this.changeStartTime = res.data.start_time.slice(0, 5);
        this.changeEndTime = res.data.start_time.slice(0, 5);
      }
    });
  }
  showDialog() {
    this.dialogVisible = true;
    getRange().then((res: any) => {
      if (res.error_code === 0) {
        this.startTime = res.data.start_time.slice(0, 5);
        if (res.data.end_time === "00:00:00") {
          res.data.end_time = "23:55:00";
        }
        this.endTime = res.data.end_time.slice(0, 5);
        this.changeStartTime = res.data.start_time.slice(0, 5);
        this.changeEndTime = res.data.start_time.slice(0, 5);
      }
    });
  }
  hideDialog() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    this.changeTime = 2;
    const start = this.startTime.slice(0, 5) + ":00";
    const end = this.endTime.slice(0, 5) + ":00";
    if (Number(start.replace(/:/g, "")) >= Number(end.replace(/:/g, ""))) {
      this.$message({
        type: "warning",
        message: "上课结束时间必须大于开始时间",
      });
      return false;
    }
    rangeSet({
      force: false,
      start_time: start,
      end_time: end,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.outside) {
          // 有范围外课次
          this.$confirm(
            "课表中存在超过此时间范围的课次，确定后超出的 课次将无法显示，同时排课时间只能选择范围时间。",
            `设置 - 课表时间`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              rangeSet({
                force: true,
                start_time: start,
                end_time: end,
              }).then((result: any) => {
                if (result.error_code === 0) {
                  this.$message({
                    type: "success",
                    message: "修改成功",
                  });
                  eventBus.$emit("schedule-range-change", [start, end]);
                  this.hideDialog();
                } else {
                  this.$message({
                    type: "error",
                    message: "修改失败：" + result.message,
                  });
                }
              });
            })
            .catch(() => {});
        } else {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.hideDialog();
          eventBus.$emit("schedule-range-change", [start, end]);
        }
      } else {
        this.$message({
          type: "error",
          message: "修改失败：" + res.message,
        });
      }
    });
  }
}
